import actionTypes from "consts/actionTypes";

import { storeWeCareID } from "actions/session";

export function cleanAccess() {
  return {
    type: actionTypes.CLEAN_CGN,
  };
}

export function getCgnAccess(weCareID) {
  if (!weCareID) {
    return null;
  }
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "GET",
          url: `/mobistar/sale/customer/public/${weCareID}`,
        },
        onStart: () => {
          return {
            type: actionTypes.GET_CGN_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch(storeWeCareID(weCareID));
          dispatch({
            type: actionTypes.GET_CGN_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.GET_CGN_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}

export function getCgnComponent(weCareID, component, language) {
  if (!weCareID) {
    return null;
  }
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "GET",
          url: `/mobistar/component/${component}/public/${language}/${weCareID}`,
        },
        onStart: () => {
          return {
            type: actionTypes.COMPONENT_QUIZZ_CGN_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          //dispatch(storeWeCareID(weCareID));
          dispatch({
            type: actionTypes.COMPONENT_QUIZZ_CGN_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.COMPONENT_QUIZZ_CGN_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}

export function updateCgnDeviceIpPolicy(weCareID, modemId, answers, policy) {
  if (!weCareID) {
    return null;
  }
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "POST",
          url: `/mobistar/sale/customer/${policy}/public/${weCareID}`,
          body: JSON.stringify({
            quizzAnswer: answers,
            device: [{
                id: modemId,
            }],
          }),
        },
        onStart: () => {
          return {
            type: actionTypes.POST_UPDATE_CGN_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          //dispatch(storeWeCareID(weCareID));
          dispatch({
            type: actionTypes.POST_UPDATE_CGN_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          // Do something if the httpCode if >= 300
          resolve();
          return {
            type: actionTypes.POST_UPDATE_CGN_ERROR,
            error: payload.error,
          };
        },
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/cgn.js